<template>
  <div class="wrap">
    <div class="searchWrap">
      <i-search ref="search" v-on:search="searchHandle"></i-search>
    </div>

    <!--sendValue-->
    <div ref="container" class="container"
         v-show="!data"
         v-if="allList">
      <i-videolist :video_newest="allList"></i-videolist>
    </div>
    <div class="none"
         v-show="data">
      <img src="../../assets/images/none.png"
           alt/>
      <p>暂无资源</p>
    </div>
  </div>
</template>
<script>
import iVideolist from "../container/videoList";
import iSearch from "../container/search";
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {
      container: 'container',
      reachBottom: true,
      params: null,
      data: false,
      allList: [],

      page: 1,
      size: 12,
      total: 0,
      isEnd: false,
      isAllowLoading: true,

      searchParams: {},
    };
  },
  props: {},

  created() {
    //this.$waiting.show(3);
  },
  methods: {
    searchHandle(params) {
      this.searchParams = params;
      this.getList(1, params)
    },
    getList(page = 1, params = {}) {
      this.isAllowLoading = false;
      this.page = page;
      this.$waiting.show(3);
      let query = this.$route.query;
      let more = JSON.parse(sessionStorage.getItem("ra_more"));
      let p = {
        title: '',
        type: '',
        order: '',
        level: more.level,
        page: page,
        size: this.size
      };

      p = {...p, ...params}

      p = Object.assign(p, query);
      // sessionStorage.setItem('ra_search',JSON.stringify(params));
      this.$postHttp(AppSetting.baseUrl + "/video/list/condition", p).then(
          res => {
            // console.log(res);
            if (res.data.code == 0) {
              let data = res.data.list;
              let total = res.data.total;

              this.isEnd = page * this.row >= total

              this.data = data.length == 0;

              this.allList = page == 1 ? data : this.allList.concat(data);

              this.$waiting.hide();

              this.isAllowLoading = true;
            }
          }
      );
    },

    onReachBottom() {
      this.isAllowLoading && !this.isEnd && this.getList(this.page + 1, this.searchParams);
    },

    containerScroll(e) {
      let container = this.$refs['container'];

      //文档内容实际高度（包括超出视窗的溢出部分）
      let scrollHeight = container.scrollHeight;
      //滚动条滚动距离
      let scrollTop = container.scrollTop;
      //窗口可视范围高度
      let clientHeight = container.clientHeight;
      localStorage.setItem('scrollTop', scrollTop);
      if (clientHeight + scrollTop >= scrollHeight - 80) {
        if (this.reachBottom) {
          console.log('onReachBottom')
          this.reachBottom = false;
          this.onReachBottom && this.onReachBottom();
        }
      } else {
        this.reachBottom || (this.reachBottom = true)
      }
    },
  },
  components: {
    iVideolist,
    iSearch
  },
  mounted() {
    //this.getList(1, {});

    let container = this.$refs['container'];
    container.addEventListener('scroll', this.containerScroll, false);
  },

  beforeDestroy() {
    let container = this.$refs['container'];
    container.removeEventListener('scroll', this.containerScroll, false);
  },

  activated() {
    if (this.$route.meta.keepAliveChange) {
      this.$refs['search'].reset();
      this.searchParams = {};
      this.allList = [];
      localStorage.setItem('scrollTop', 0);
      this.getList(1, {});
      console.log('----------------keepAliveChange:true')
    } else {
      console.log('----------------keepAliveChange:false')
      let scrollTop = localStorage.getItem('scrollTop');
      let container = this.$refs['container'];
      container.scrollTop = scrollTop ? scrollTop : 0;
    }
  }

};
</script>
<style scoped lang="scss">
.wrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  .searchWrap {
    flex-grow: 0;
  }
}

.none {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding-top: 2.64rem;
  box-sizing: border-box;

  img {
    width: 100%;
  }

  p {
    font-size: 0.38rem;
    color: #666666;
    text-align: center;
  }
}

.container {
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  flex-grow: 1;
  overflow-y: auto;
  // margin-top: 1.1rem;
  /*margin-bottom: 1.18rem;*/
}
</style>



// WEBPACK FOOTER //
// src/components/video/alllist.vue